import React, { useState, useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { FaSave, FaRegEnvelope, FaUser, FaRegUser, FaRegStar, FaCheckCircle } from "react-icons/fa";
import Button from 'react-bootstrap/Button';
import { useToasts } from 'react-toast-notifications';
import { connect } from 'react-redux';
import { Formik } from "formik";
import * as yup from "yup";
import './UserDetail.css';
import '../../../components/PageHeader/PageHeader.css';
import PageHeader from '../../../components/PageHeader/PageHeader';
import { useI18n } from '../../../i18n';
import { API } from 'aws-amplify';
const Aws = require('aws-sdk');

Aws.config.update({
    accessKeyId: process.env.REACT_APP_accessKeyId,
    secretAccessKey: process.env.REACT_APP_secretAccessKey,
    region: 'eu-west-1'  
});
const cognitoIdentityService = new Aws.CognitoIdentityServiceProvider({apiVersion: '2016-04-19', region: 'eu-west-1'});


const UserDetail = (props) => {
    const { t } = useI18n();
    const [isLoading, setIsLoading] = useState(false);   
    const [contractorList, setContractorList] = useState([]);

    let url = window.location.href
    let parts = url.split('/');
    let username = parts.pop() || parts.pop();  // handle potential trailing slash

    let API_USER_ACCESS = process.env.REACT_APP_GLOBAL_API + '/user_app_access_get?id=' + props.match.params.id;
    const CityApiToken = process.env.REACT_APP_CITY_API_TOKEN;
    let headers = {
        'x-api-key': CityApiToken,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      };

    const [btnDisabled, setBtnDisabled] = useState(false);
    const [ user, setUser] = useState({  name: '',
                                        username:'',
                                        admin:'',
                                        contractor:'',
                                        status:'',
                                        confirmed: '',
                                        enabled: '',
                                        emailVerified: false,
                                        web: 'false',
                                        mobile: 'false',
                                        reporting: 'false',
                                        chkWeb: false,
                                        chkMobile: false,
                                        chkReporting: false
                                    });
    const { addToast } = useToasts();
    const params = { 
        headers: {
            'x-api-key': process.env.REACT_APP_API_KEY,        
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
    }
    useEffect(() => {
        
        fetch(API_USER_ACCESS, {
            method: 'GET',
            headers,
            })
            .then((response) => {
            if (!response.ok) throw Error(response.statusText);
            return response.json();
            })
            .then((responseJson) => {
            let responseData = responseJson[process.env.REACT_APP_GLOB_APP_ENV]
            let accountStatus = responseData["accountStatus"] === 'true'
            let res = responseData["app_access"]
            let contractorGlobal = responseData["contractor"]
            let adminGlobal = responseData["isAdmin"]
            if (adminGlobal === 1) adminGlobal=true; else adminGlobal=false

            let userGlobal = {}
            if (res != null){
                if (res.includes("web")!=null){
                    if (res.includes("web") === true){
                        userGlobal.chkWeb = true
                    } else{
                        userGlobal.chkWeb = false
                    }
                }
                if (res.includes("mobile")!=null){
                    if (res.includes("mobile") === true){
                        userGlobal.chkMobile = true
                    } else{
                        userGlobal.chkMobile = false
                    }
                }
                if (res.includes("mobile-reporting")!=null){
                    if (res.includes("mobile-reporting") === true){
                        userGlobal.chkReporting = true
                    } else{
                        userGlobal.chkReporting = false
                    }
                }
               
            } 
            let userGlobalspread = {
                ...user,
                ...userGlobal
            };

            const fetchUser = async () => {
                setIsLoading(true);
                // console.log('Load user')
                if (props.match.params.id){ 
     
                    const contractors = await API.get('settings','/CONTRACTORS', params)
                    contractors.values.sort((a, b) => (a > b) ? 1 : -1)
    
        
                    let list = []
                    for (let i = 0; i < contractors.values.length; i++) {
                        list.push(<option key={contractors.values[i]} value={contractors.values[i]}>{contractors.values[i]}</option>)
                    }
        
                    setContractorList(list);
                    // props.match.params.id
                    API.get('users','/' + props.match.params.id, params)
                    .then(resultList => {
                        // console.log(resultList)
                        let usr ={}
                        usr.contractor = contractorGlobal
                        usr.admin = adminGlobal
                        usr.username = resultList.Username;
                        resultList.UserAttributes.forEach(e => {
                            if (e.Name === 'name') {
                                usr.name = e.Value;
                            }
                            if (e.Name === 'email_verified') {
                                usr.emailVerified = (e.Value === 'true' || e.Value === true);
                            }
                            // if (e.Name === 'custom:administrator') {
                            //     usr.admin = true;
                            // }       
                        })
    
                        usr.status = resultList.UserStatus;
                        usr.enabled = accountStatus;
                        // usr.accountStatus = accountStatus;

                        
                        if (usr.status === 'CONFIRMED')
                            usr.confirmed = 'checked';
                        else
                            usr.confirmed = '';    
                                           
                        let resSpread = {
                            ...userGlobalspread,
                            ...usr
                        };

                        // console.log(resSpread, "spreadddd")
                        
    
                        setUser(resSpread);  
                        setIsLoading(false);
    
                    }).catch(error => {
                        // console.log("errrrrr", error)
                        setIsLoading(false);
                        addToast(t('toast.errorSavingUser') + ': ' + error, { appearance: 'error' });
                    });  
    
                }
                                        
            }
            
            fetchUser();	
            

            }).catch((error) => {
                console.log('request failed loading the api' + error);
            });   
        }, [username, props.match.params.id]);

    
	const handleSubmit = (data) => {

        if (user.chkWeb) data.web='true'; else data.web ='false';
        if (user.chkMobile) data.mobile='true'; else data.mobile ='false';
        if (user.chkReporting) data.reporting='true'; else data.reporting ='false';

        let headerglobal = {
            'x-api-key': process.env.REACT_APP_CITY_API_TOKEN,        
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
        let lsAppAccess = []
        if (user.chkMobile === true){
            lsAppAccess.push("mobile")
        }
        if (user.chkReporting === true){
            lsAppAccess.push("mobile-reporting")
        }
        if (user.chkWeb === true){
            lsAppAccess.push("web")
        }

        let adminData
        
        if (data.admin === "true") {
            adminData = 1
        }
        else {
            adminData = 0
        }

        API.put('user_access', `${process.env.REACT_APP_GLOB_APP_ENV}/` + data.username, {      
            body: {              
                [`${process.env.REACT_APP_GLOB_APP_ENV}`] : {
                "isAdmin": adminData,
                "app_access": lsAppAccess,
                "contractor": data.contractor,
                "accountStatus": data.enabled.toString()
                },
            },
            headers: headerglobal,
        })
        .then(res => {               
            return API.post('user_update', '/' + data.username, {      
                body: {
                    name: data.name,
                    admin: "true",
                    contractor: data.contractor,
                    web: data.web,
                    mobile: data.mobile,
                    reporting: data.reporting,
                },
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,        
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            });
        })
        .then(res => {               
            // Show toast notification first
            addToast(t('toast.userSaved'), { appearance: 'success' });
            
            var params = {
                UserPoolId: process.env.REACT_APP_USER_POOL_ID, /* required */
                Username: data.username /* required */
              };
              cognitoIdentityService.adminUserGlobalSignOut(params, function(err, data) {
                if (err) console.log(err, err.stack); // an error occurred
                else     console.log("sign out:",data);           // successful response
              });
              
            // Use requestAnimationFrame to ensure toast is rendered before redirect
            requestAnimationFrame(() => {
                setTimeout(() => {
                    props.history.push('/users/');
                }, 1500);
            });         
        }).catch(error => {
            console.log(error)
            addToast(t('toast.errorSavingUser') + ': ' + error, { appearance: 'error' });
        });  
        setBtnDisabled(true); 
	};

    // Update the global account status flag using the reliable user_access endpoint (same as Save)
    const syncAccountStatus = (enabled) => {
        let headerglobal = {
            'x-api-key': process.env.REACT_APP_CITY_API_TOKEN,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
        let lsAppAccess = []
        if (user.chkMobile === true) lsAppAccess.push("mobile")
        if (user.chkReporting === true) lsAppAccess.push("mobile-reporting")
        if (user.chkWeb === true) lsAppAccess.push("web")
        let adminData = (user.admin === true || user.admin === 1 || user.admin === "true") ? 1 : 0

        return API.put('user_access', `${process.env.REACT_APP_GLOB_APP_ENV}/` + props.match.params.id, {
            body: {
                [`${process.env.REACT_APP_GLOB_APP_ENV}`]: {
                    "isAdmin": adminData,
                    "app_access": lsAppAccess,
                    "contractor": user.contractor,
                    "accountStatus": enabled ? "true" : "false"
                },
            },
            headers: headerglobal,
        })
    };

    const handleDisableUser = () => {
        // Disable the account in Cognito, then update the global account status flag
        API.get('user_disable', '/' + props.match.params.id, params)
        .then(() => syncAccountStatus(false))
        .then(res => {
            setUser({...user, enabled: false}) 
            addToast(t('toast.userDisabled'), { appearance: 'success' });
        }).catch (e => {
            console.log(e)
            addToast(t('toast.errorDisablingUser'), { appearance: 'error' });  
		})
    };

    const handleEnableUser = () => {
        // Enable the account in Cognito, then update the global account status flag
        API.get('user_enable', '/' + props.match.params.id, params)
        .then(() => syncAccountStatus(true))
        .then(res => {
            setUser({...user, enabled: true}) 
            addToast(t('toast.userEnabled'), { appearance: 'success' });
        }).catch (e => {
            console.log(e)
            addToast(t('toast.errorEnablingUser'), { appearance: 'error' });  
		})
    };

    const handleConfirmUser = () => {
        API.get('user_confirm','/' + props.match.params.id, params)
        .then(res => {

            // email verified
            API.post('user_update', '/' + props.match.params.id, {      
                body: {
                    email_verified: true,
                },
                headers: {
                    'x-api-key': process.env.REACT_APP_API_KEY,        
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            }); 

            setUser({...user, status: 'CONFIRMED'}) 
        }).catch(e => {
            addToast(e.message, { appearance: 'error' });
		})
    };

    const handleVerifyEmail = () => {
        API.get('user_verify_email', '/' + props.match.params.id, params)
        .then(res => {
            setUser({ ...user, emailVerified: true });
            addToast(t('toast.emailVerified'), { appearance: 'success' });
        }).catch(err => {
            console.log(err);
            addToast(t('toast.errorVerifyingEmail'), { appearance: 'error' });
        });
    };

    const handleResetPassword = () => {
        API.get('user_reset_pwd','/' + props.match.params.id, params)
        .then(res => {                
            // setUser({...user, status: 'CONFIRMED'}) 
            console.log(res)
            addToast(t('toast.passwordResetSent'), { appearance: 'success' });
        }).catch (e => {
            console.log(e)
            addToast(e.message, { appearance: 'error' });
		})
    }

    const schema = yup.object().shape({
        username: yup.string()
            .required(t('common.required')),
        name: yup.string()
            .required(t('common.required')),
        contractor: yup.string()
            .required(t('common.required')),
        admin: yup.string(),
        });

	return (
        !isLoading ? (
        <Formik //enableReinitialize               
        initialValues={user}
        validationSchema={schema}
        onSubmit={ (values, { setSubmitting }) => {
            setBtnDisabled(true);
            handleSubmit(values);
            setSubmitting(false);
        }}

        >
        {({values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (

		<div className="UserDetail">  
        <form key="form" onSubmit={handleSubmit}> 
            <PageHeader
                title={t('pages.editUser.title')}
                breadcrumbs={[
                    { label: t('nav.users'), path: '/users' },
                    { label: user.username || t('pages.editUser.user') },
                ]}
                backTo="/users"
                backLabel={t('nav.users')}
                subtitle={t('pages.editUser.subtitle')}
                actions={
                    <>
                        <Button variant="success" type="submit" disabled={btnDisabled}>
                            {t('actions.save')} <FaSave />
                        </Button>
                        {(user.status !== 'CONFIRMED' && user.enabled) ?
                            <Button variant="info" type="button" onClick={() => handleConfirmUser()}>
                                {t('users.confirmEmail')} <FaRegEnvelope />
                            </Button> : ''}
                        {(!user.emailVerified && user.enabled) ?
                            <Button variant="info" type="button" onClick={() => handleVerifyEmail()}>
                                {t('users.verifyEmail')} <FaCheckCircle />
                            </Button>
                            : (user.enabled ?
                                <Button variant="outline-success" type="button" disabled title={t('users.emailIsVerified')}>
                                    {t('users.emailVerifiedBtn')} <FaCheckCircle />
                                </Button> : '')}
                        {user.enabled ? (
                            <Button variant="danger" type="button" onClick={() => handleDisableUser()}>
                                {t('users.disableUser')} <FaUser />
                            </Button>
                        ) : (
                            <Button variant="warning" type="button" onClick={() => handleEnableUser()}>
                                {t('users.enableUser')} <FaRegUser />
                            </Button>
                        )}
                        <Button variant="info" type="button" onClick={() => handleResetPassword()}>
                            {t('login.resetPassword')} <FaRegStar />
                        </Button>
                    </>
                }
            />
            
			<div className="row div-content">
                <div className="col-md-6">
				<Form.Group controlId="username"  >
					<Form.Label>{t('fields.email')}</Form.Label>
                    <Form.Control 
                        type="input" 
                        value={values.username} 
                        disabled />
				</Form.Group>

				<Form.Group controlId="name" className={touched.name && errors.name ? "has-error" : null} >
					<Form.Label>{t('fields.name')}</Form.Label>
                    <Form.Control
                        autoFocus 
                        type="input" 
                        value={values.name} 
                        onChange={handleChange}
                        // onChange={(e) => setUser({...user, name: e.target.value})} 
                    />
                     {touched.name && errors.name ? <div className="error-message">{errors.name}</div> : null}
				</Form.Group>
				<Form.Group controlId="contractor" className={touched.contractor && errors.contractor ? "has-error" : null} >
					<Form.Label>{t('common.contractor')}</Form.Label>
                    <Form.Control 
                        as="select" 
                        value={values.contractor} 
                        onChange={handleChange}
                        // onChange={(e) => setUser({...user, contractor: e.target.value})}
                    >
						<option key="cont1" value=""></option>
						{contractorList}
					</Form.Control>
                    {touched.contractor && errors.contractor ? <div className="error-message">{errors.contractor}</div> : null}
				</Form.Group>	
				<Form.Group controlId="admin" >
					<Form.Label>{t('fields.administrator')}</Form.Label>
                    <Form.Control 
                        as="select"  
                        value={values.admin} 
                        onChange={handleChange}
                        // onChange={(e) =>  setUser({...user, admin: e.target.value})}
                    >
						<option key="adm1" value="false">{t('users.no')}</option>
						<option key="adm2" value="true">{t('users.yes')}</option>						
					</Form.Control>
				</Form.Group>	
                </div>
                <div className="col-md-6">
                <div className="col-md-12 p-3 mt-4 bg-light border border-secondary rounded text-center">					
					<h4><strong>{t('fields.applicationAccess')}</strong></h4><br/>
					<Form.Check className="p-3" 
						inline 
						type="checkbox" 
						id="web" 
                        label="Web" 
                        checked={user.chkWeb}
                        // onChange={handleChange}
						onChange={(e) => setUser({...user, chkWeb: e.target.checked})} 
                        />
					<Form.Check className="p-3" 
						inline 
						type="checkbox" 
						id="mobile" 
                        label="Mobile"
                        checked={user.chkMobile}
                        // onChange={handleChange}
						onChange={(e) => setUser({...user, chkMobile: e.target.checked})} 
                        />
					<Form.Check className="p-3" 
						inline 
						type="checkbox" 
						id="reporting" 
                        label="Mobile Reporting"
                        checked={user.chkReporting}
                        // onChange={handleChange}
						onChange={(e) => setUser({...user, chkReporting: e.target.checked})} 
                        />
					</div>	
                </div>
			</div>
            </form>
        </div>
        )}
        </Formik>   ) : ''    
	);

}

const mapStateToProps = state => {
	return {
		user: state.auth.user,
	};
};

export default connect( mapStateToProps )( UserDetail );